/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';

import {ChangeTrackingComponent} from './change-tracking.component';
import {ChangeTrackingService} from './change-tracking.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiModule,
    TranslateModule,
    PipesModule
  ],
  declarations: [
    ChangeTrackingComponent
  ],
  exports: [
    ChangeTrackingComponent
  ]
})
export class ChangeTrackingModule {
  public static forRoot(): ModuleWithProviders<ChangeTrackingModule> {
    return {
      ngModule: ChangeTrackingModule,
      providers: [
        ChangeTrackingService
      ]
    };
  }
}
